export class Distributore {
  _id: string;
  codice: string;
  descrizione: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Distributore.ts